import * as React from "react";
import { BooleanInput as Input } from "kanopi-components/BooleanInput";
import { FormControl } from "kanopi-components/Input";
import { WidthContainer } from "../../ChatFlow/WidthContainer";

type BooleanInputProps = {
  label: string;
  title: string;
  help: string;
  showLabel: boolean;
  error: string;
  onBlur: () => void;
  [key: string]: any;
};

export function BooleanInput({
  label,
  title,
  help,
  showLabel,
  error,
  onBlur,
  ...props
}: BooleanInputProps) {
  return (
    <WidthContainer>
      <FormControl
        label={showLabel ? label : undefined}
        caption={help}
        title={title}
        hideLabel={!showLabel}
        error={error}
           overrides={{
            Label: {
              style: {
                transform: "translate(0, 0)",
                fontWeight: "bold",
                marginBottom: "18px"
              },
            },
          }}
      >
        <Input onBlur={onBlur} {...props}
        />
      </FormControl>
    </WidthContainer>
  );
}
